import { OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
var SliderComponent = /** @class */ (function () {
    function SliderComponent() {
        this.theme = 'dark';
        this.min = 0;
        this.max = 100;
        this._value = 0;
        this.disabled = false;
        // Both onChange and onTouched are functions
        this.onChange = function () { };
        this.onTouched = function () { };
        this.propagateChange = function (_) { };
    }
    Object.defineProperty(SliderComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (value != null) {
                if (this._initialValue == null) {
                    this._initialValue = value;
                }
                this._value = value;
                this.propagateChange(this.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    SliderComponent.prototype.ngOnInit = function () {
    };
    SliderComponent.prototype.handleRangeDoubleClick = function () {
        this.value = this._initialValue;
    };
    SliderComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    SliderComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    SliderComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SliderComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return SliderComponent;
}());
export { SliderComponent };
